// // components/AddNewClientModal.jsx
// import React, { useState, useEffect } from 'react'
// import ApiClient from '../../../../api/client'
// import Logo from '../../../../../assets/logo.png'

// const apiClient = new ApiClient()

// const SummaryModal = ({ onCancel }) => {
//   // const [formData, setFormData] = useState({
//   //   client_name: '',
//   //   email: '',
//   //   program_id: '',
//   //   // add more fields as needed
//   // })

//   const [name, setName] = useState('')
//   const [new_code, setNewCode] = useState('')
//   const [image, setImage] = useState(null)
//   const [program, setProgram] = useState([])
//   const [statusOption, setStatusOption] = useState([])

//   const statuses = [
//     { id: 1, name: 'RBI' },
//     { id: 2, name: 'CBI' },
//   ]

//   // const handleChange = (e) => {
//   //   const { name, value } = e.target
//   //   setFormData((prev) => ({
//   //     ...prev,
//   //     [name]: value,
//   //   }))
//   // }

//   useEffect(() => {
//     const fetchProgram = async () => {
//       const { data, error } = await apiClient.fetchAllPrograms()
//       if (data) {
//         setProgram(data)
//       }
//     }
//     fetchProgram()

//     setStatusOption(statuses)
//   }, [])

//   const handleSubmit = async (e) => {
//     e.preventDefault()
//     await addProgram(name, image, new_code)
//     onCancel() // close modal after success
//   }

//   if (!onCancel) return null

//   return (
//     <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex justify-center items-center">
//       <div className="bg-white w-[90%] max-w-9xl p-6 rounded-md shadow">
//         <h2 className="text-4xl font-semibold mb-4 text-center">
//           Client Summary
//         </h2>
//         <div className="relative p-8 bg-white print:bg-white">
//           <img
//             src={Logo}
//             alt=""
//             className="absolute inset-0 m-auto w-[300px] h-auto opacity-10 pointer-events-none select-none z-0 print:opacity-10"
//             style={{
//               top: '0%',
//               //   left: '50%',
//               //   transform: 'translate(-50%, -50%)',
//             }}
//           />
//           <form
//             onSubmit={handleSubmit}
//             className="space-y-4 relative z-10"
//             autoComplete="off"
//           >
//             <input
//               type="text"
//               name="client_name"
//               placeholder="Program Name"
//               value={name}
//               onChange={(e) => setName(e.target.value)}
//               className="w-full p-2 border border-gray-300 rounded"
//               required
//             />
//             {/* <select
//             name="status"
//             id="status"
//             value={status}
//             className="w-full border mb-4 p-2 rounded"
//             onChange={(e) => setStatus(e.target.value)}
//             placeholder="Status"
//           >
//             <option value="">Select program category</option>
//             {statuses
//               ? statusOption.map((e) => (
//                   <option key={e.id} value={e.name}>
//                     {e.name}
//                   </option>
//                 ))
//               : alert(<span className="text-red-700">Select an option!</span>)}
//           </select> */}
//             <input
//               type="file"
//               name="image"
//               placeholder="image"
//               accept="image/*"
//               onChange={(e) => setImage(e.target.files[0])}
//               className="w-full p-2 border border-gray-300 rounded"
//             />
//             <input
//               type="text"
//               name="new_code"
//               placeholder="Program new code"
//               value={new_code}
//               onChange={(e) => setNewCode(e.target.value)}
//               className="w-full p-2 border border-gray-300 rounded"
//             />
//             {/* Add dropdown if you want to show program names later */}
//             <div className="flex justify-end space-x-2">
//               <button
//                 type="button"
//                 onClick={onCancel}
//                 className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
//               >
//                 Cancel
//               </button>
//               <button
//                 type="submit"
//                 className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
//               >
//                 Print
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default SummaryModal

// components/AddNewClientModal.jsx
import { useState, useEffect } from 'react'
import ApiClient from '../../../../api/client'
import Logo from '../../../../../assets/logo.png'
import { useParams } from 'react-router-dom'

const apiClient = new ApiClient()

const SummaryModal = ({ onCancel }) => {
  const { clientId } = useParams()
  const [summary, setSummary] = useState([])
  //   const [clear, setClear] = useState(false)

  useEffect(() => {
    const fetchSummary = async () => {
      const { data, error } = await apiClient.fetchSummary(clientId)
      if (data) {
        setSummary(data)
      }
    }
    fetchSummary()
  }, [])

  if (!onCancel) return null

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex justify-center items-center">
      <div className="bg-white w-[80%] max-w-6xl py-12 px-8 rounded-md shadow">
        <div className="flex justify-center gap-4 items-center">
          <div>
            <img
              src={summary.client_image}
              alt=""
              className="h-12 w-12 rounded-full"
            />
          </div>
          <div>
            <p className="text-xl font-bold">{summary.client_name}</p>
            <p>{summary.client_phone}</p>
            <p>{summary.client_email}</p>
          </div>
        </div>
        {/* <hr /> */}
        <div className="relative p-8 bg-white print:bg-white">
          <img
            src={Logo}
            alt=""
            className="absolute inset-0 m-auto w-[300px] h-auto opacity-10 pointer-events-none select-none z-0 print:opacity-10 h-[100%] w-[40%]"
            style={
              {
                //   top: '10%',
                //   left: '50%',
                //   transform: 'translate(-50%, -50%)',
              }
            }
          />
          <h2 className="text-xl font-semibold mb-4 text-left">
            Family Documentation Status
          </h2>
          <hr />
          <div className="overflow-x-auto mt-6">
            <table className="min-w-full border-collapse">
              {/* Table Head */}
              <thead>
                <tr className="text-left text-gray-700 font-semibold border-b">
                  <th className="py-3 px-4">Client_ID</th>
                  <th className="py-3 px-4">Name</th>
                  <th className="py-3 px-4">Relationship</th>
                  <th className="py-3 px-4">Status</th>
                  <th>Percentage</th>
                </tr>
              </thead>

              {/* Table Body */}
              <tbody className="text-gray-800">
                {summary.family_members?.map((member, index) => (
                  <tr key={index} className="border-b">
                    <td className="py-3 px-4">{member.member_id}</td>
                    <td className="py-3 px-4">{member.member_name}</td>
                    <td className="py-3 px-4 capitalize">
                      {member.relationship}
                    </td>
                    <td className="py-3 px-4 capitalize">
                      {member.uploaded} of {member.required}
                    </td>
                    <td>{member.percentage}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="pt-6">
              <div>
                <p>
                  <span className="text-blue-900 font-bold">
                    Total files uploaded:
                  </span>{' '}
                  <span className="font-bold">{summary.total_uploaded}</span>
                </p>
                <p>
                  <span className="text-blue-900 font-bold">
                    Total files required:
                  </span>{' '}
                  <span className="font-bold">{summary.total_required}</span>
                </p>
                <p>
                  <span className="text-blue-900 font-bold">Out-standing:</span>{' '}
                  <span className="font-bold">
                    {Math.ceil(summary.total_required - summary.total_uploaded)}
                  </span>
                </p>
                <p>
                  <span className="text-blue-900 font-bold">
                    Total percentage:
                  </span>{' '}
                  <span className="font-bold">
                    {summary.percentage_completion}%
                  </span>
                </p>
              </div>
            </div>
          </div>{' '}
        </div>
        <div className="flex justify-end space-x-2 print:hidden">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            type="submit"
            onClick={() => window.print()}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Print
          </button>
        </div>
      </div>
    </div>
  )
}

export default SummaryModal
